import React from 'react';
import { IControlledField } from '../../types';

const HiddenField: React.FC<IControlledField> = ({ controller, inputName }) => (
  <input type="hidden" ref={controller.ref} name={inputName} />
);

export default HiddenField;
